import { FetchInterceptor } from "src/app/helpers/Index";
import { environment } from "src/environments/environment";

const endpoint = "Scoreboard";
export const ScoreboardService = {
	endpoint,
	getTheme: async (configId?: number) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/GetTheme${configId ? `?configId=${configId}` : ""}`, { headers: { "Content-Type": "application/json" }, method: "GET" }),
	saveTheme: async (data: any, configId?: number) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/SaveTheme${configId ? `?configId=${configId}` : ""}`, { body: JSON.stringify(data), headers: { "Content-Type": "application/json" }, method: "POST" }),
}
